module.exports = __webpack_public_path__ + "img/134.c23eef4d.png";